import WidgetMobileVelocityAndAccessibility from "./widget-mobile-velocity-and-accessibility";

export default WidgetMobileVelocityAndAccessibility;